<template>
  <div class="animated fadeIn"> 
    <b-row>
      <b-col sm="12">
        <b-card>
          <div slot="header">
            <strong>Reattempt Shipments</strong>           
          </div>
          <div class="box">
           <form>
            <b-row>
              <b-col md="6"> 
              <b-col sm="12" >                            
                <b-form-group label="Delivery Agent"  :label-cols="4" >
                   <!-- <b-form-select class="form-control input" v-model="customer.deliveryagentmasterid" name="deliveryagentname" v-validate="'required|'" :class="{'input': true, }">
                        <option :value="selected"  >--Select--</option>
                        <option  :value="customer.deliveryagentmasterid" v-for="customer in data1"  :disabled="customer.capacityforallocation== 0">{{ customer.deliveryagentfirstname | capitalize }} {{ customer.deliveryagentlastname | capitalize }} - {{ customer.deliveryagentmobilenumber }}</option>
                   </b-form-select> -->
                   <v-select  v-model="customer.deliveryagentmasterid" :options="data1" placeholder="Select Delivery Agent" @input="selectdeliveryagent(customer.deliveryagentmasterid)" name="deliveryagentname" v-validate="'required|'" :class="{'input': true, }">
                  </v-select>

                  <span v-show="errors.has('form-1.shipmentid')" class="help is-danger">{{ errors.first('form-1.shipmentid') }}</span>             
                </b-form-group> 
              </b-col>
              </b-col>
              <b-col md="6">
                <b-button class="mr-2" @click="markRTO"  size="md" variant="primary">RTO</b-button>
                <b-button size="md" variant="danger"  @click="redirecttoDashborard" :disabled="!this.customer.deliveryagentmasterid">Re-Attempt</b-button> 
              </b-col> 
            </b-row>     
          </form>
          </div>
          <div class="table-responsive" >
            <b-col sm="12" >
            <table class="table table-striped table-bordered" border="1" >
              <thead v-if="data.length > 0" >
                <tr>
                  <th>Sr.No.</th>
                  <th>Shipping ID</th>
                  <th>Shipment Status</th>
<!--                   <th>Ship Location Id</th>
 -->                  <th>delivery status</th>
                  <th>pickup location address</th>
                  <th>NDR Reason</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(value, firstIndex) in data">
                  <td><input class="shipmentscheckbox" type="checkbox"  v-bind:value="value.shippingid"/></td>
                  <td>{{ value.shippingid }}</td>
                  <td>{{ value.shipmentstatus }}</td>
<!--                   <td>{{ value.shippincode }}</td>
 -->                  <td>{{ value.deliverystatus }}</td>
                  <td>{{ value.pickuplocationaddress }}</td>
                  <td>{{value.ndrreason}}</td>
                </tr>
              </tbody>
            </table>
          </b-col>
          </div>
       </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CONSTANTS from '@/utils/constants'
import Utils from '@/utils'
export default {
  data: function() {
    return {
      name: 'reattemptshipment',
      data: [],
      data1: [],
      customer: {},
     selected:'selected'
    }
  },
  created: function() {
    // alert("ok")
    this.displaydata()
  },
  methods: {
    displaydata: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      const deliveryagent = {
        deliveryagentpincode: `${userInfo.pickuplocationpincode}`,
        isactive: '1'
      }
      this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/deliveryagentmastergetall`, deliveryagent)
        .then((result) => {
          this.data1 = result.body;
          var data = [];
 
          result.body.forEach(function (srData) {
            data.push({
              key:srData.deliveryagentmasterid,
              label:srData.deliveryagentmasterid+ ' - '+srData.deliveryagentfirstname+ ' - '+srData.deliveryagentlastname
            });
          });
          this.data1 = data;
        })
        .catch((ex) => {
          console.log('error', ex)
        })
      var pincode=userInfo.pickuplocationpincode;
      // var hubid=userInfo.pickuplocationmasterid;
      var shipments={
        pickuplocationpincode:pincode.toString(),
         hub_id:`${userInfo.pickuplocationmasterid}`,
         // hub_id:hubid.toString(),
      }
     // console.log("shipments",shipments);
     // return false;
      this.$http
        .post(
          `${CONSTANTS.API_URL}/ConsignmentMaster/GetAllNDRshipments`,
          shipments
        )
        .then(result => {
          console.log("Result",result);
          console.log("Params",shipments);
          //  if (result.body.returnmsg=== 'Successful') {
            this.data = result.body;
            console.log("kkk",this.data);
                  // }
            // else{
            //   // alert("Result not found");
            //   this.$fire({
            //       text:"Result not found",
            //       type: "warning",
            //       timer: 30000
            //     }); 
            // }
        })
        .catch(ex => {
          console.log('error', ex)
        })
    },
    markRTO: function() {
        var userdata = localStorage.getItem('userData')
        var userInfo = JSON.parse(userdata)
        var y = document.getElementsByClassName('shipmentscheckbox')
        var shippingIds=[];
        var rto={};
        if(y.length>0){
          for (var i = 0; i < y.length; i++) {
              if (y[i].checked == true){
                shippingIds.push(y[i].value)
              }
          }
          rto.shippingid=shippingIds;
            rto.lastmodifiedby=userInfo.sysemailid;
            rto.callby='cms';
            rto.mobilenumber=userInfo.usermobilenumber;
            console.log("!!!!!!!!!!!",rto)
            // return false
            this.$http.post(`${CONSTANTS.MIGRATION_API_URL}/markrtoshipments`, rto)
              .then((result) => {
                if (result.body.returnmsg=== 'Successful') {
                  alert('Shipment marked rto')
                  this.displaydata();
                    var x = document.getElementsByClassName('shipmentscheckbox')
                      for (var i = 0; i < x.length; i++) {
                        if (x[i].checked == true){
                          x[i].checked=false;
                          document.getElementsByClassName('shipmentscheckbox').value=x
                      }
                    }
                  this.data=[];
               
                } else {
                    Utils.notify('shippingid must contain at least 1 items'+result.body.returnmsg,'error')

                }
              })
              .catch((ex) => {
                console.log('error-----', ex)
              })
            }else{
              Utils.notify('shippingid must contain at least 1 items');
            }
        
    },
    redirecttoDashborard: function() {
      var userdata = localStorage.getItem('userData')
      var userInfo = JSON.parse(userdata)
      var y = document.getElementsByClassName('shipmentscheckbox')
      var shippingIds=[];
      var reattempt={};
      if(y.length>0){
        for (var i = 0; i < y.length; i++) {
            if (y[i].checked == true){
              shippingIds.push(y[i].value)
            }
        }
      }
      reattempt.shippingid=shippingIds;
      reattempt.deliveryagentmasterid=this.customer.deliveryagentmasterid.key;
      reattempt.lastmodifiedby=userInfo.sysemailid;
      reattempt.mobilenumber=userInfo.usermobilenumber;
      console.log("@@@@@@@@@@@",reattempt)
      // return false;
      this.$http.post(`${CONSTANTS.API_URL}/ConsignmentMaster.svc/ConsignmentMasterReallocation`, reattempt)
        .then((result) => {
          // console.log('--------------------');
          // console.log(result.body[0].returnmsg);
          //           console.log('--------------------');
          if (result.body[0].returnmsg === 'Successful') {


            alert('Shipment reattempted successfully')
            this.displaydata();
            var x = document.getElementsByClassName('shipmentscheckbox')
            for (var i = 0; i < x.length; i++) {
              if (x[i].checked == true){
                x[i].checked=false;
                document.getElementsByClassName('shipmentscheckbox').value=x
              }
            }
             this.data=[];
          } else {
            alert(result.body.returnmsg)
            
          }
        })
        .catch((ex) => {
          console.log('error-----', ex)
        })
    },
    selectdeliveryagent(value_vehicle) {
        if(value_vehicle==null){
          this.customer.deliveryagentmasterid = '';
          this.displaydata();
        }
         console.log("value_vehicle : ",value_vehicle);
    },
  },
  filters: {
    datechange: function(value) {
       if(value==null){
       return '-';
      }else{
        var d = new Date(value)
        var curr_date = (d.getDate() < 10 ? '0' : '') + d.getDate();
        var month = d.getMonth() + 1;
        var curr_year = d.getFullYear();
        var curr_month = month < 10 ? '0' + month : '' + month;
        var hours = d.getHours();
        var minutes = d.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return curr_date + '-' + curr_month + '-' + curr_year+'  '+ " " + strTime;

      }
    },
     capitalize: function(value) {
            return value.toUpperCase() || "";
        }
  }
}
</script>
